var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1931 10.5L30.3862 16.5896V25.9098C30.3862 27.2828 29.2691 28.3999 27.8961 28.3999H12.4901C11.1171 28.3999 10 27.2828 10 25.9098V16.5896L20.1931 10.5ZM12.6193 16.9169L20.094 21.5777L20.1327 21.5985C20.139 21.6018 20.1449 21.6048 20.1533 21.608L20.1623 21.6102C20.1834 21.6153 20.1931 21.6156 20.1934 21.6156C20.1934 21.6156 20.2034 21.6153 20.2297 21.6091L20.2343 21.608C20.241 21.6053 20.2484 21.6018 20.2581 21.5969C20.2687 21.5909 20.2795 21.585 20.2903 21.5793L27.7667 16.9169L20.1931 12.3923L12.6193 16.9169ZM12.4901 26.7756H27.8961C28.3735 26.7756 28.7617 26.3874 28.7617 25.9103V18.2108L21.1294 22.9699C21.1015 22.9875 21.0733 23.0032 21.0438 23.0184C21.0279 23.027 21.0122 23.0354 20.9973 23.0427C20.8787 23.1039 20.7579 23.1505 20.6439 23.1803L20.5811 23.1952C20.4495 23.225 20.3193 23.2401 20.1923 23.2401C20.0661 23.2401 19.9351 23.2247 19.8027 23.1944L19.7485 23.1819C19.6286 23.1508 19.5076 23.1039 19.3914 23.0438C19.3746 23.0354 19.3581 23.0268 19.3408 23.0173L11.6245 18.21V25.9098C11.6245 26.3874 12.0128 26.7756 12.4901 26.7756Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.4f3b03c889798b9fd52adf83f2bc9ccc.svg";
export { ForwardRef as ReactComponent };